import React from "react";
import { Modal } from "antd";
import NoteEditor from "./NoteEditor.tsx";

// ⬇️ Импорт из одного источника
import type { Note } from "../types/note";
import type { EditorProps } from "./NoteEditor.tsx";

interface Props extends EditorProps {
  open: boolean;
}

export default function NoteModal({
  open,
  note,
  onCancel,
  onSave,
  onDelete,
}: Props) {
  return (
<Modal
  open={open}
  onCancel={onCancel}
  footer={null}
  centered
  width="70vw"
  style={{ top: 24 }}
  bodyStyle={{
    padding: 0,
    maxHeight: "80vh", // ограничение
    overflow: "auto",  // позволяет прокрутку
  }}
  destroyOnClose
>


      <NoteEditor
        note={note}
        onSave={onSave}
        onCancel={onCancel}
        onDelete={onDelete}
      />
    </Modal>
  );
}
